import React from 'react';
import { localeService } from '../../../core';
export const CallSurveyHeader = ({ title, subtitle }) => {
    return (<div className="call-quality-survey__header">
      <div className="call-quality-survey__title">
        {localeService.formatMessageById(title)}
      </div>
      <div className="call-quality-survey__subtitle">
        {localeService.formatMessageById(subtitle)}
      </div>
    </div>);
};
